import { EditIconDisableV3, EditIconV3 } from '@/shared/ui/assets';
import { DOUBLE_HYPHEN_BULLET } from '@/shared/config';
import { CustomButton } from '@/shared/ui/components';
import _ from 'lodash';
import Skeleton from 'react-loading-skeleton';
import { ReactSVG } from 'react-svg';
import { t } from 'ttag';
import SupportParticipant from './supportParticipant/supportParticipant';
import ModalEditEmail from './modalEditEmail/modalEditEmail';
import { useSupportRequestInfo } from './useSupportRequestInfo';
import type { SupportRequestInfoProps } from './supportRequestInfo.types';
import './supportRequestInfo.scss';

const SupportRequestInfo = ({
  isLoadedData = true,
  detailData,
  handleUpdateEmail,
}: SupportRequestInfoProps) => {
  const { facility } = detailData || {};

  const { supportFacilities, state, listEmail, isOpen, handleToggleModal } = useSupportRequestInfo({
    detailData,
  });

  if (!isLoadedData) {
    return (
      <div className="info-participant-wrapper">
        <Skeleton height={500} />
      </div>
    );
  }

  return (
    <>
      <div className="info-participant-wrapper">
        {(supportFacilities?.length ?? 0) > 1 && (
          <div className="part-facility">
            <div className="title">{t`Facility`}</div>
            <div className="content">{facility?.name || DOUBLE_HYPHEN_BULLET}</div>
          </div>
        )}
        <div className="part-notification-email">
          <div className="title">
            {t`Notification email`}
            <CustomButton
              id="edit-notification-email-btn"
              style="neutral"
              type="tertiary"
              className="edit-noti-email-btn"
              tooltipPlacement="bottomLeft"
              tooltipTitle={
                isOpen
                  ? t`Edit notification email`
                  : t`You cannot edit the notification email of a resolved request.`
              }
              disabled={!isOpen}
              icon={<ReactSVG src={isOpen ? EditIconV3 : EditIconDisableV3} />}
              onClick={handleToggleModal}
              ariaLabel={t`Edit notification email`}
            />
          </div>
          <div className="content">
            <div className="content-list">
              {_.map(listEmail, (item) => (
                <>
                  <div className="email-user">{item}</div>
                  <br />
                </>
              ))}
            </div>
          </div>
        </div>
        <SupportParticipant detailData={detailData} />
      </div>
      <ModalEditEmail
        isOpen={state.isOpenEditModal}
        onClose={handleToggleModal}
        data={listEmail}
        handleUpdateEmail={handleUpdateEmail}
      />
    </>
  );
};

export default SupportRequestInfo;
